import { defineComponent, onMounted, onUnmounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import ClientServicesPersonCode from '@/presentation/components/campaign-management/client-services-person/client-services-person.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		MultiSelect
	},
	setup: () => {
		const code = new ClientServicesPersonCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			loadingType: code.loadingType,
			clientServicesPersonDropdown: code.clientServicesPersonDropdown,
			options: code.options,
			isLoading: code.isLoading,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			setClientServicesPerson: code.setClientServicesPerson.bind(code)
		};
	}
});
